import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongsMobileFilterGroupDifficultyLogic} from "./SongsMobileFilterGroupDifficulty.logic";
import {DisclosureGroup} from "../../../../../../components/common/disclosure-group/DisclosureGroup";
import {
  FilterDifficultyCategories
} from "../../../../../../modules/songs/filter-difficulty-categories/FilterDifficultyCategories";

export const SongsMobileFilterGroupDifficulty: VoidFunctionComponent = () => {
  const {filterLabel} = useSongsMobileFilterGroupDifficultyLogic();
  return (
    <DisclosureGroup title={"Difficulty"} secondaryInfo={filterLabel}>
      <FilterDifficultyCategories />
    </DisclosureGroup>
  );
}
